import React from "react";
import { useTranslate } from "@refinedev/core";
import type { usePageStyles } from "../../../shared/styles";

type PageStyles = ReturnType<typeof usePageStyles>;

type AccountStatusActionsProps = {
  onActivate: () => void;
  onDeactivate: () => void;
  styles: PageStyles;
};

export const AccountStatusActions: React.FC<AccountStatusActionsProps> = ({
  onActivate,
  onDeactivate,
  styles,
}) => {
  const _t = useTranslate();

  return (
    <div className="flex gap-3 mb-8" style={{ marginBottom: '32px', display: 'flex', gap: '12px' }}>
      <button
        style={{
          ...styles.primaryButton,
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          boxShadow: '0 4px 20px rgba(16, 185, 129, 0.3)'
        }}
        onClick={onActivate}
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {_t('accounts.titles.activate')}
      </button>
      <button
        style={{ ...styles.headerButton, ...styles.dangerButton }}
        onClick={onDeactivate}
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="6" y1="6" x2="18" y2="18" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {_t('accounts.titles.deactivate')}
      </button>
    </div>
  );
};
